import styled from "styled-components";
import { useDetailModal, useFaceOnUploadModal } from "../contexts/ModalContext";
import { useSquad } from "../contexts/SquadContext";
import Modal from "./Modal";
import PlayerCard from "./PlayerCard";
import Enforce0 from "../assets/images/ic_enforce_0.svg"
import Enforce1 from "../assets/images/ic_enforce_1.svg"
import Enforce2 from "../assets/images/ic_enforce_2.svg"
import Enforce3 from "../assets/images/ic_enforce_3.svg"
import Enforce4 from "../assets/images/ic_enforce_4.svg"
import Enforce5 from "../assets/images/ic_enforce_5.svg"
import Enforce6 from "../assets/images/ic_enforce_6.svg"
import Enforce7 from "../assets/images/ic_enforce_7.svg"
import Enforce8 from "../assets/images/ic_enforce_8.svg"
import Enforce9 from "../assets/images/ic_enforce_9.svg"
import Enforce10 from "../assets/images/ic_enforce_10.svg"
import Awaken1 from "../assets/images/ic_awaken_1.svg"
import Awaken2 from "../assets/images/ic_awaken_2.svg"
import Awaken3 from "../assets/images/ic_awaken_3.svg"
import Awaken4 from "../assets/images/ic_awaken_4.svg"
import Awaken5 from "../assets/images/ic_awaken_5.svg"
import Awaken6 from "../assets/images/ic_awaken_6.svg"
import Awaken7 from "../assets/images/ic_awaken_7.svg"
import Awaken8 from "../assets/images/ic_awaken_8.svg"
import Awaken9 from "../assets/images/ic_awaken_9.svg"
import LevelPopup from "./LevelPopup";
import { useState } from "react";
import NumberInput from "./NumberInput";
import { calculateMaxSpecialTrainLevel, calculateMaxTrainLevel, getMaxTrainStates } from "../utils/calculateMaxTrainLevel";
import { calculatePositionTrainStates, getMaxPositionTrainAdditionalStates, getMaxPositionTrainStates, getMaxSpecialTrainStates, getPositionTrainAdditionalStatesText } from "../utils/calculatePositionTrainStates";
import { SelectPopup } from "./SelectPopup";
import { teamKeys } from "../utils/publicKeys";
import calculateNumberOfFaPlayer from "../utils/calculateNumberOfFaPlayer";
import { calculatePlayerSetDeckPoint } from "../utils/calculateSetDeckPoint";

const ModalContainer = styled.div`
    position: relative;
    height: 43.75rem;
    display: flex;
    flex-direction: column;
    background-color: white;
    padding: 1.875rem 2.25rem;
`

const HorizontalContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
`

const PlayerInfoContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 1.875rem;
    border-bottom: 0.0625rem solid #CDCDCD;
`

const VerticalContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const PlayerName = styled.div`
    font-family: 'Esamanru', sans-serif;
    font-size: 1.625rem;
    font-weight: 500;
    color: #000000;
`

const LevelButton = styled.img`
    margin-left: 0.425rem;
    z-index: 4; 
    &:hover {
        cursor: pointer;
    }
`

const EnforceLevelButton = styled(LevelButton)`
    width: 1.5rem;
`
const AwakenLevelButton = styled(LevelButton)`
    width: 2.125rem;
`

const EnforceMap = {
    0: Enforce0,
    1: Enforce1,
    2: Enforce2,
    3: Enforce3,
    4: Enforce4,
    5: Enforce5,
    6: Enforce6,
    7: Enforce7,
    8: Enforce8,
    9: Enforce9,
    10: Enforce10,
}

const AwakenMap = {
    1: Awaken1,
    2: Awaken2,
    3: Awaken3,
    4: Awaken4,
    5: Awaken5,
    6: Awaken6,
    7: Awaken7,
    8: Awaken8,
    9: Awaken9,
}

const LevelPopupContainer = styled.div`
    position: absolute; 
    top: 2.5rem;
    right: 0rem;
    z-index: 10;
`


const FaPopupContainer = styled.div`
    position: absolute; 
    top: 2.5rem;
    right: 0rem;
    z-index: 10;
`

const PlayerTypeText = styled.div`
    font-family: 'Esamanru', sans-serif;
    font-size: 1.125rem;
    font-weight: 300;
    color: #000000;
    margin-top: 0.0625rem;
`

const StateText = styled.div`
    font-family: 'Esamanru', sans-serif;
    font-size: 1.125rem;
    font-weight: 300;
    color: #000000;
`

const StatesGridContainer = styled.div`
    display: grid;
    direction: ltr;
    grid-template-rows: repeat(3, auto);
    grid-template-columns: repeat(3, auto);
    gap: 0.5rem 1rem;
    margin-top: 1rem;
`
const ExtraStateText = styled.div`
    font-family: 'Esamanru', sans-serif;
    font-size: 0.75rem;
    font-weight: 300;
    color: #A939FF;
    margin-left: 0.125rem;
`

const AdditionalStateContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
`

const StateSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: space-between;
    gap: 0.75rem;
`

const AdditionalStateTitle = styled.div`
    font-family: 'Esamanru', sans-serif;
    font-size: 1.25rem;
    font-weight: 500;
    color: #000000;
`

const AdditionalStateLabel = styled.div`
    font-family: 'Pretendard Variable';
    font-size: 1.125rem;
    font-weight: 400;
    color: #000000;
    margin-right: 0.3125rem;
`

const AdditionalStateHorizontalContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.625rem;
`

const FaButton = styled.div`
    position: absolute;
    top: 1.875rem;
    right: 2.25rem;
    padding: 0.4375rem 1.25rem;
    background-color: #545454;
    font-family: 'Pretendard Variable';
    font-size: 1rem;
    font-weight: 600;
    color: white;
    border-radius: 0.375rem;
    cursor: pointer;
    z-index: 10;
`

const FaceOnButton = styled.div`
    position: absolute;
    top: 1.875rem;
    right: 8.2rem;
    padding: 0.4375rem 1.25rem;
    background-color: #A939FF;
    font-family: 'Pretendard Variable';
    font-size: 1rem;
    font-weight: 600;
    color: white;
    border-radius: 0.375rem;
    cursor: pointer;
    z-index: 10;
`

const PreCompletedStateButton = styled.div`
    padding: 0.225rem 0.725rem;
    background-color: #545454;
    font-family: 'Pretendard Variable';
    font-size: 1rem;
    color: white;
    border-radius: 0.375rem;
    cursor: pointer;
    z-index: 10;
`

const minTrainedStates = {level: 0, s1:0, s2:0, s3:0, s4:0, s5:0 ,s6:0}

export default function DetailModal() {

    const { isDetailModalOpen, openDetailModal, closeDetailModal } = useDetailModal();
    const { openFaceOnUploadModal } = useFaceOnUploadModal();
    const { playerInfos, addPlayer, removePlayer } = useSquad();

    const [levelPopupVisible, setLevelPopupVisible] = useState(false);
    const [isSelectTeamPopupVisible, setIsSelectTeamPopupVisible] = useState(false)
    const [selectedFaTeam, setSelectedFaTeam] = useState(null)

    const player = playerInfos[isDetailModalOpen];

    console.log("Detail Model :",player)

    if (!player) {
        return null;
    }

    const stateKeys = ['s1', 's2', 's3', 's4', 's5', 's6'];
    const stateLabelMap = player.isPitcher ? 
        {'s1': '구속', 's2': "변화", 's3': "구위", 's4': "제구", 's5': "지구력", 's6': "수비"}
        :
        {'s1': '파워', 's2': "정확", 's3': "선구", 's4': "인내", 's5': "주루", 's6': "수비"}

    const additionalStates = stateKeys.reduce((acc, key)=> {

        let additionalState = 0;

        additionalState += player.enforcedStates[key] || 0;
        additionalState += player.awakenStates[key] || 0;
        additionalState += player.trainedStates[key] || 0;
        additionalState += player.specialTrainedStates[key] || 0;
        additionalState += player.positionTrainedStates[key] || 0;
        additionalState += player.positionTrainedAdditionalStates[key] || 0;
        additionalState += player.synergyStates[key] || 0;
        additionalState += player.setDeckStates[key] || 0;
        additionalState += player.faStates[key] || 0;

        acc[key] = additionalState;
        return acc;
    }, {});

    function reduceRandomState(player, count, stateType) {
        let remainingCount = count;
        const resultStates = { ...player[stateType] }; 

        if (count <= 0) return player;

        while (remainingCount > 0) {
            const reducibleKeys = stateKeys.filter(key => resultStates[key] > 0);

            if (reducibleKeys.length === 0) break;

            const randomIndex = Math.floor(Math.random() * reducibleKeys.length);
            const selectedKey = reducibleKeys[randomIndex];

            resultStates[selectedKey]--;
            remainingCount--;
        }

        return {
            ...player,
            [stateType]: resultStates
        };
    }

    const onTrainLevelChanged = (newValue) => {

        const maxTrainLevel = calculateMaxTrainLevel(player)
        const currentTotalTrainStates = stateKeys.map((key) => player.trainedStates[key] || 0).reduce((a, b) => a + b, 0);

        if (newValue < 0) { 
            alert("훈련 레벨은 0 이상이어야 합니다.");
            return;
        } else if (newValue > maxTrainLevel) {
            alert(`훈련 레벨은 최대 ${maxTrainLevel}레벨까지 설정할 수 있습니다.`);
            return;
        } else if (currentTotalTrainStates > newValue * 3) {
            const reducedState = reduceRandomState(player, currentTotalTrainStates - newValue * 3, 'trainedStates');
            addPlayer(isDetailModalOpen, {
                ...reducedState,
                trainedStates: {
                    ...reducedState.trainedStates,
                    level: newValue
                }
            });
            return;
        } else {
            addPlayer(isDetailModalOpen, {
                ...player,
                trainedStates: {
                    ...player.trainedStates,
                    level: newValue
                }
            });
            return;
        }
    }

    const onTrainStateChanged = (stateKey, newValue) => {
        const currentTrainLevel = player.trainedStates.level || 0;
        const currentTotalTrainStates = stateKeys.map((key) => player.trainedStates[key] || 0).reduce((a, b) => a + b, 0);
        const maxTrainStates = currentTrainLevel * 3;
        const newTotalTrainStates = currentTotalTrainStates - (player.trainedStates[stateKey] || 0) + newValue;

        if (newValue < 0) {
            alert("훈련 스탯은 0 이상이어야 합니다.");
            return;
        } else if (newTotalTrainStates > maxTrainStates) {
            alert(`훈련 스탯의 총합은 현재 훈련 레벨(${currentTrainLevel}레벨) 기준 최대 ${maxTrainStates}까지 설정할 수 있습니다.`);
            return;
        }   
        addPlayer(isDetailModalOpen, {
            ...player,
            trainedStates: {
                ...player.trainedStates,
                [stateKey]: newValue
            }
        });
    }

    const onTrainMaxClicked = () => {
        const maxTrainStates = getMaxTrainStates(player);

        addPlayer(isDetailModalOpen, {
            ...player,
            trainedStates: maxTrainStates
        });
    }

    const onTrainMinClicked = () => {
        addPlayer(isDetailModalOpen, {
            ...player,
            trainedStates: minTrainedStates
        });
    }

    const onSpecialTrainLevelChanged = (newValue) => {

        const maxSpecialTrainLevel = calculateMaxSpecialTrainLevel(player);
        const currentTotalSpecialTrainStates = stateKeys.map((key) => player.specialTrainedStates[key] || 0).reduce((a, b) => a + b, 0);

        const speacialTrainAvailableTypes = ['임팩트', '시그니쳐', '국가대표', '골든글러브'];

        if (newValue < 0) { 
            alert("특훈 레벨은 0 이상이어야 합니다.");
            return;
        } else if(!speacialTrainAvailableTypes.includes(player.type) && newValue > 0) {
            alert("이 선수 유형은 특훈 레벨을 설정할 수 없습니다.");
            return;
        } else if (newValue > maxSpecialTrainLevel) {
            alert(`특훈 레벨은 최대 ${maxSpecialTrainLevel}레벨까지 설정할 수 있습니다.`);
            return;
        } else if (currentTotalSpecialTrainStates > newValue) {
            const reducedState = reduceRandomState(player, currentTotalSpecialTrainStates - newValue, 'specialTrainedStates');
            addPlayer(isDetailModalOpen, {
                ...reducedState,
                specialTrainedStates: {
                    ...reducedState.specialTrainedStates,
                    level: newValue
                }
            });
            return;
        } else {
            addPlayer(isDetailModalOpen, {
                ...player,
                specialTrainedStates: {
                    ...player.specialTrainedStates,
                    level: newValue
                }
            });
            return;
        }
    }

    const onSpecialTrainStateChanged = (stateKey, newValue) => {
        const currentSpecialTrainLevel = player.specialTrainedStates.level || 0;
        const currentTotalSpecialTrainStates = stateKeys.map((key) => player.specialTrainedStates[key] || 0).reduce((a, b) => a + b, 0);
        const maxSpecialTrainStates = currentSpecialTrainLevel;
        const newTotalSpecialTrainStates = currentTotalSpecialTrainStates - (player.specialTrainedStates[stateKey] || 0) + newValue;

        if (newValue < 0) {
            alert("특훈 스탯은 0 이상이어야 합니다.");
            return;
        } else if (newTotalSpecialTrainStates > maxSpecialTrainStates) {
            alert(`특훈 스탯의 총합은 현재 특훈 레벨(${currentSpecialTrainLevel}레벨) 기준 최대 ${maxSpecialTrainStates}까지 설정할 수 있습니다.`);
            return;
        }   
        addPlayer(isDetailModalOpen, {
            ...player,
            specialTrainedStates: {
                ...player.specialTrainedStates,
                [stateKey]: newValue
            }
        });
    }

    const onSpecialTrainMaxClicked = () => {
        const maxSpecialTrainStates = getMaxSpecialTrainStates(player);

        addPlayer(isDetailModalOpen, {
            ...player,
            specialTrainedStates: maxSpecialTrainStates
        });
    }

    const onSpecialTrainMinClicked = () => {
        addPlayer(isDetailModalOpen, {
            ...player,
            specialTrainedStates: minTrainedStates
        });
    }

    const onPositionTrainLevelChanged = (newValue) => {

        const maxPositionTrainLevel = 20;

        if (newValue < 0) { 
            alert("특훈 레벨은 0 이상이어야 합니다.");
            return;
        } else if (newValue > maxPositionTrainLevel) {
            alert(`포지션 특훈 레벨은 최대 ${maxPositionTrainLevel}레벨까지 설정할 수 있습니다.`);
            return;
        } else {

            const increasedState = calculatePositionTrainStates(player, newValue, isDetailModalOpen);
            addPlayer(isDetailModalOpen, {
                ...player,
                positionTrainedStates: {
                    level: newValue,
                    ...increasedState
                }
            });

            return;
        }
    }


    // 이미 존재: O, 변경할 값 크기: 3, 현재 갯수 : 2 -> 가능
    // 이미 존재: O, 변경할 값 크기: 4, 현재 갯수 : 2 -> 불가능 
    // 이미 존재: O, 변경할 값 크기: 4, 현재 갯수 : 1 -> 가능
    // 이미 존재: X, 변경할 값 크기: 1, 현재 갯수 : 2 -> 불가능
    // 이미 존재: X, 변경할 값 크기: 1, 현재 갯수 : 1 -> 가능
    const onPositionTrainStateChanged = (stateKey, newValue) => {

        const additionalValue = newValue - (player.positionTrainedStates[stateKey] || 0);

        const activatedStates = Object.keys(player.positionTrainedAdditionalStates).filter(key => player.positionTrainedAdditionalStates[key] !== 0);
        const currentPositionTrainLevel = player.positionTrainedStates.level || 0;
        
        // 5 미만은 0, 5 이상은 1, 15이상은 2
        const additionalPositionTrainLevel = currentPositionTrainLevel >= 15 ? 2 : (currentPositionTrainLevel >= 5 ? 1 : 0);

        if (additionalValue < 0) {
            alert("포지션 특훈 스탯은 0 이상이어야 합니다.");
            return;
        } else if(additionalValue > 6) {
            alert("포지션 특훈 스탯은 최대 6까지 설정할 수 있습니다.");
            return;
        } else if(activatedStates.includes(stateKey) && (additionalValue > 3 && activatedStates.length >= additionalPositionTrainLevel)) {
            alert(`포지션 특훈 스탯은 현재 포지션 특훈 레벨(${currentPositionTrainLevel}레벨) 기준 최대 ${additionalPositionTrainLevel}개의 스탯만 1 이상으로 설정할 수 있습니다.`);
            return;
        } else if(!activatedStates.includes(stateKey) && activatedStates.length >= additionalPositionTrainLevel) {
            alert(`포지션 특훈 스탯은 현재 포지션 특훈 레벨(${currentPositionTrainLevel}레벨) 기준 최대 ${additionalPositionTrainLevel}개의 스탯만 1 이상으로 설정할 수 있습니다.`);
            return;
        } else {
            addPlayer(isDetailModalOpen, {
                ...player,
                positionTrainedAdditionalStates: {
                    ...player.positionTrainedAdditionalStates,
                    [stateKey]: additionalValue
                }
            });

            return;
        }
    }

    const onPositionMaxClicked = () => {
        const maxPositionTrainStates = getMaxPositionTrainStates(player, isDetailModalOpen);
        const maxPositionTrainAdditionalStates = getMaxPositionTrainAdditionalStates(player, isDetailModalOpen);

        addPlayer(isDetailModalOpen, {
            ...player,
            positionTrainedStates: maxPositionTrainStates,
            positionTrainedAdditionalStates: maxPositionTrainAdditionalStates
        });
    }

    const onPositionMinClicked = () => {
        addPlayer(isDetailModalOpen, {
            ...player,
            positionTrainedStates: minTrainedStates,
            positionTrainedAdditionalStates: minTrainedStates
        });
    }

    const SelectedLevelButton = player ? (player.isAwaken ? AwakenLevelButton : EnforceLevelButton) : null;

    const CurrentLevelSrc = player ? (player.isAwaken ? AwakenMap[player.level] : EnforceMap[player.level]) : null;
    
    const onLevelButtonClick = () => {
        setLevelPopupVisible(true);
    }
    
    const onLevelSelected = (levelInfo) => {
        addPlayer(isDetailModalOpen, {
            ...player,
            level: levelInfo.level,
            isAwaken: levelInfo.isAwaken
        });
        setLevelPopupVisible(false);
    }

    const onFaButtonClicked = () => {

        const numberOfFaPlayer = calculateNumberOfFaPlayer(playerInfos)

        if (player.isFa) {
            addPlayer(isDetailModalOpen, {
                ...player,
                isFa: null,
                faStates: {s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
            });
        } else {
            if(!(['임팩트', '시그니쳐'].includes(player.type))) {
                alert("임팩트, 시그니쳐 외의 선수는 FA 영입을 할 수 없습니다.");
            } else if(numberOfFaPlayer >= 2) {
                alert("FA 선수 수는 2를 초과할 수 없습니다.");
            } else {
                setIsSelectTeamPopupVisible(true)
            }
        }
    }

    const onFaTeamSelected = (team) => {

        if (team === player.team) {
            alert("선수의 현재 소속팀으로는 FA 영입을 할 수 없습니다.");
            return 
        }

        addPlayer(isDetailModalOpen, {
            ...player,
            isFa: team,
            faStates: {s1: -3, s2: -3, s3: -3, s4: -3, s5: -3, s6: -3 },
        });
        setIsSelectTeamPopupVisible(false);
    }

    const setDeckPoint = calculatePlayerSetDeckPoint(player, playerInfos)

    return (
        (isDetailModalOpen && <Modal
            isOpen={isDetailModalOpen} 
            onClose={closeDetailModal}
        > 
            <ModalContainer>

                <FaButton onClick={onFaButtonClicked}>
                    {player.isFa ? 'FA 취소' : 'FA 영입'}
                </FaButton>

                <FaceOnButton onClick={() => {
                    openFaceOnUploadModal();
                }}>
                    페이스온 추가
                </FaceOnButton>

                <FaPopupContainer>
                    <SelectPopup
                        isVisible={isSelectTeamPopupVisible}
                        gridCols={3}
                        onClose={() => {setIsSelectTeamPopupVisible(false)}}
                        onSelect={(team) => {
                            onFaTeamSelected(team)
                        }}
                        initialValue={player.isFa ? player.isFa : player.team}
                        items={teamKeys}
                    />
                </FaPopupContainer>

                <PlayerInfoContainer>
                    <PlayerCard
                        player={player}
                        onClick={() => {}}
                    />

                    <div style={{'width' : '1.375rem'}}></div>

                    <VerticalContainer>
                        <HorizontalContainer>
                            <PlayerName>
                                {player.type === '임팩트' ? player.description+" " : player.type} {player.playerName}{player.year != null ? ('\''+player.year) : ""}
                            </PlayerName>

                            <SelectedLevelButton onClick={onLevelButtonClick} src={CurrentLevelSrc}></SelectedLevelButton>
                                
                            <LevelPopupContainer>
                                {levelPopupVisible && <LevelPopup 
                                    isVisible={levelPopupVisible}
                                    onClose={() => setLevelPopupVisible(false)}
                                    onLevelSelected={onLevelSelected}
                                    isAllowAwaken={['임팩트', '시그니쳐', '국가대표', '골든글러브'].includes(player.type)}
                                />}
                            </LevelPopupContainer>
                        </HorizontalContainer>

                        <PlayerTypeText>
                            {player.type} 선수
                        </PlayerTypeText>

                        <StatesGridContainer>   
                            {stateKeys.map((key) => (
                                <HorizontalContainer style={{width: '9rem'}}>
                                    <StateText>
                                        {stateLabelMap[key]}: {player.originalStates[key] + additionalStates[key]}
                                    </StateText>

                                    <ExtraStateText>
                                        ({player.originalStates[key]}+{additionalStates[key]})
                                    </ExtraStateText>
                                </HorizontalContainer>
                            ))}
                        
                            <HorizontalContainer>
                                <StateText>
                                    세트덱 포인트 : {setDeckPoint}
                                </StateText>
                            </HorizontalContainer>
                        </StatesGridContainer>
                    </VerticalContainer>
                </PlayerInfoContainer>

                <AdditionalStateContainer>
                    <StateSectionContainer>
                        <AdditionalStateTitle>훈련</AdditionalStateTitle>

                        <AdditionalStateHorizontalContainer>
                            <HorizontalContainer>
                                <AdditionalStateLabel>훈련 레벨 :</AdditionalStateLabel>
                                <NumberInput
                                                                        value={player.trainedStates.level}
                                    onChange={(newValue) => {onTrainLevelChanged(newValue)}}
                                />
                            </HorizontalContainer>

                            <HorizontalContainer>
                                <AdditionalStateLabel>훈련 총합 : {stateKeys.map((key) => player.trainedStates[key] || 0).reduce((a, b) => a + b, 0)}/{player.trainedStates.level*3}</AdditionalStateLabel>
                            </HorizontalContainer>

                            <PreCompletedStateButton onClick={onTrainMinClicked}>
                                0
                            </PreCompletedStateButton>

                            <PreCompletedStateButton onClick={onTrainMaxClicked}>
                                {calculateMaxTrainLevel(player)}
                            </PreCompletedStateButton>
                        </AdditionalStateHorizontalContainer>
                        
                        <AdditionalStateHorizontalContainer>
                            {stateKeys.map((key) => (
                                <HorizontalContainer>
                                    <AdditionalStateLabel>{stateLabelMap[key]} :</AdditionalStateLabel>
                                    <NumberInput
                                                                                value={player.trainedStates[key] || 0}
                                        onChange={(newValue) => {onTrainStateChanged(key, newValue)}}
                                    />
                                </HorizontalContainer>
                            ))}
                        </AdditionalStateHorizontalContainer>
                    </StateSectionContainer>
                    
                    <StateSectionContainer>
                        <AdditionalStateTitle>특훈</AdditionalStateTitle>

                        <AdditionalStateHorizontalContainer>
                            <HorizontalContainer>
                                <AdditionalStateLabel>특훈 레벨 :</AdditionalStateLabel>
                                <NumberInput
                                                                        value={player.specialTrainedStates.level}
                                    onChange={(newValue) => {onSpecialTrainLevelChanged(newValue)}}
                                />
                            </HorizontalContainer>

                            <HorizontalContainer>
                                <AdditionalStateLabel>특훈 총합 : {stateKeys.map((key) => player.specialTrainedStates[key] || 0).reduce((a, b) => a + b, 0)}/{player.specialTrainedStates.level}</AdditionalStateLabel>
                            </HorizontalContainer>

                            <PreCompletedStateButton onClick={onSpecialTrainMinClicked}>
                                0
                            </PreCompletedStateButton>

                            <PreCompletedStateButton onClick={onSpecialTrainMaxClicked}>
                                {calculateMaxSpecialTrainLevel(player)}
                            </PreCompletedStateButton>
                        </AdditionalStateHorizontalContainer>

                        <AdditionalStateHorizontalContainer>
                            {stateKeys.map((key) => (
                                <HorizontalContainer>
                                    <AdditionalStateLabel>{stateLabelMap[key]} :</AdditionalStateLabel>
                                    <NumberInput
                                                                                value={player.specialTrainedStates[key] || 0}
                                        onChange={(newValue) => {onSpecialTrainStateChanged(key, newValue)}}
                                    />
                                </HorizontalContainer>
                            ))}
                        </AdditionalStateHorizontalContainer>
                    </StateSectionContainer>

                    <StateSectionContainer>
                        <AdditionalStateTitle>포지션 특훈</AdditionalStateTitle>

                        <AdditionalStateHorizontalContainer>
                            <HorizontalContainer>
                                <AdditionalStateLabel>포지션 특훈 레벨 :</AdditionalStateLabel>
                                <NumberInput
                                                                        value={player.positionTrainedStates.level}
                                    onChange={(newValue) => {onPositionTrainLevelChanged(newValue)}}
                                />
                            </HorizontalContainer>

                            <HorizontalContainer>
                                <AdditionalStateLabel>포지션 특훈 총합 : {stateKeys.map((key) => player.positionTrainedStates[key] || 0).reduce((a, b) => a + b, 0)} {getPositionTrainAdditionalStatesText(player)}</AdditionalStateLabel>
                            </HorizontalContainer>

                            <PreCompletedStateButton onClick={onPositionMinClicked}>
                                0
                            </PreCompletedStateButton>

                            <PreCompletedStateButton onClick={onPositionMaxClicked}>
                                20
                            </PreCompletedStateButton>
                        </AdditionalStateHorizontalContainer>

                        <AdditionalStateHorizontalContainer>
                            {stateKeys.map((key) => (
                                <HorizontalContainer>
                                    <AdditionalStateLabel>{stateLabelMap[key]} :</AdditionalStateLabel>
                                    <NumberInput
                                                                                value={(player.positionTrainedStates[key] + player.positionTrainedAdditionalStates[key])|| 0}
                                        onChange={(newValue) => {onPositionTrainStateChanged(key, newValue)}}
                                    />
                                </HorizontalContainer>
                            ))}
                        </AdditionalStateHorizontalContainer>
                    </StateSectionContainer>
                </AdditionalStateContainer>
            </ModalContainer>
        </Modal>)
    )
}